import { Component, inject } from '@angular/core';
import { FormArray, FormBuilder } from '@angular/forms';
import { IIconColumn } from '../../../dashboards/interfaces/tiles/definition-helpers/icon-column.interface';
import { IIconColumnsTileInstance } from '../../../dashboards/interfaces/tiles/definitions/icon-columns-tile-definition.interface';
import { HORIZONTAL_POSITION_OPTIONS } from '../../constants/horizontal-position-options.constant';
import { ISelectOption } from '../../interfaces/select-option.interface';
import { TileCreatorHelpersService } from '../../services/tile-creator-helpers.service';
import { TileCreatorService } from '../../services/tile-creator.service';
import { TILE_REQUEST } from '../../tokens/tile-request.token';
import { TileSetupWizardComponent } from '../tile-setup-wizard.component';

@Component({
  standalone: false,
  selector: 'lib-icon-columns-setup-wizard',
  templateUrl: './icon-columns-setup-wizard.component.html',
  styleUrls: ['../shared-tile-creator-styles.scss', './icon-columns-setup-wizard.component.scss'],
})
export class IconColumnsSetupWizardComponent extends TileSetupWizardComponent<IIconColumnsTileInstance> {
  iconColumns;

  horizontalPositionOptions: ISelectOption[];
  fontSizesOptions: string[];

  constructor(
    private readonly fb: FormBuilder,
    private readonly tileCreatorHelpersService: TileCreatorHelpersService,
    private readonly tileCreatorService: TileCreatorService,
  ) {
    super();

    this.tileInstance = inject(TILE_REQUEST).tileInstance;
  }

  ngOnInit() {
    this.initSelectOptions();
    this.initSetupForms();

    this.hookForm();
  }

  initSelectOptions() {
    this.horizontalPositionOptions = HORIZONTAL_POSITION_OPTIONS;
    this.fontSizesOptions = this.tileCreatorHelpersService.generateFontSize();
  }

  initSetupForms() {
    this.setupForm = this.fb.group({
      iconColumns: this.fb.array([]),
      background: [''],
    });

    if (this.tileInstance) {
      this.setupForm.patchValue(this.tileInstance);

      this.tileInstance.iconColumns?.forEach((iconColumn: IIconColumn) => {
        this.addIconColumn(iconColumn);
      });
    } else {
      this.addIconColumn();
    }

    this.iconColumns = this.setupForm.controls.iconColumns;
  }

  addIconColumn(iconColumn?: IIconColumn) {
    const iconColumnFormGroup = this.fb.group({
      heading: [''],
      headingFontSize: ['6px'],
      headingFontColor: ['#000000'],
      text: [''],
      textFontSize: ['6px'],
      textFontColor: ['#000000'],
      icon: [''],
      iconPosition: ['start'],
    });

    iconColumnFormGroup.patchValue(iconColumn);

    (this.setupForm.controls.iconColumns as FormArray).push(iconColumnFormGroup);
  }

  removeIconColumn(iconColumnIndex: number) {
    (this.setupForm.controls.iconColumns as FormArray).removeAt(iconColumnIndex);
  }

  onCreate() {
    Object.assign(this.tileInstance, this.getChanges());
    this.tileCreatorService.onChange.next();
  }

  getChanges() {
    return {
      tileType: 'icon-columns',
      canView: 'true',
      ...this.setupForm.value,
    };
  }
}
